export default __webpack_public_path__ + "6738231e2cbcbbc4747dc28de165c94c.svg";